import { themeCfg } from '../../theme/theme.ts'
import { Box, Container, Group, ScrollArea, Stack } from '@mantine/core'
import React from 'react'
import AppHeaderView from './AppHeaderView.tsx'

interface CustomProps extends React.PropsWithChildren {
  title?: string
  dataFacade?: any
  header?: string | React.ReactNode
  subheader?: string | React.ReactNode
  toolbar?: string | React.ReactNode
  headerOptions?: any
  mainContainer?: 'group' | 'scrollarea'
}

const AppSection = ({
  title,
  dataFacade,
  header,
  subheader,
  toolbar,
  headerOptions,
  mainContainer = 'group',
  ...otherProps
}: CustomProps) => {
  return (
    <Stack
      {...otherProps}
      className="app-main-container"
      w="100%"
      gap={0}
      h={`calc(100dvh - (${Number(themeCfg?.headerSize) + Number(0)}px + ${Number(10) * 2}px))`}
      bg={themeCfg?.debug ? 'blue' : undefined}
    >
      {header && header}
      {subheader && subheader}
      {(dataFacade || toolbar) && toolbar}

      {headerOptions && (
        <Group mih={50} h={50}>
          <AppHeaderView {...headerOptions} dataFacade={dataFacade} />
        </Group>
      )}

      <Group
        className="app-main-viewport"
        // style={dataFacade ? undefined : { overflow: "scroll" }}
        // style={{ overflowY: "hidden" }}
        w="100%"
        h="100%"
        mih={240}
        align="flex-start"
        p={themeCfg?.debug ? 0 : 0}
        mb={themeCfg?.default?.padding}
      >
        {otherProps?.children}
      </Group>

      {/* 
      {mainContainer === "scrollarea" && (
          <ScrollArea
            className="app-main-viewport"
            w="100%"
            h="100%"
            p={themeCfg?.debug ? 0 : 0}
            // scrollbars="xy"
            // bg="blue"
            mb={themeCfg?.default?.padding}
          >
            {otherProps?.children}
          </ScrollArea>
      )} */}
    </Stack>
  )
}

export default AppSection
